import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type { ZuubManualCheckDetailsResponse } from '@/@types/zuub/contracts';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { endpoints } from '../endpoints';

/**
 * Fetches manual-check details for a given requestId (e.g. from list row selection).
 * Uses Practice and Org headers. Only runs when requestId and practice/org are present.
 */
export const useZuubManualCheckDetails = (requestId: string | null) => {
  const {
    primaryPracticeId: practiceId,
    primaryOrganizationId: organizationId,
  } = useSelector(
    (state: {
      login: {
        user: {
          primaryPracticeId?: string;
          primaryOrganizationId?: string;
        };
      };
    }) => state.login.user,
  );

  return useQuery<ZuubManualCheckDetailsResponse>(
    ['zuubManualCheckDetails', requestId],
    () =>
      makeAPIRequestReactQueryWithHeaders<ZuubManualCheckDetailsResponse>(
        endpoints.zuubManualCheckDetails(requestId!),
        {},
        {
          Org: organizationId,
          Practice: practiceId,
        },
        'GET',
      ),
    {
      enabled: Boolean(requestId && practiceId && organizationId),
    },
  );
};
